import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

export type TDeleteKeepingSessionParams = {
  id: string;
};

export function deleteKeepingSession({ id }: TDeleteKeepingSessionParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/time_keeping_sessions/${id}`);
}

type MutationFn = typeof deleteKeepingSession;

type TUseDeleteKeepingSessionParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteKeepingSession({ config = {} }: TUseDeleteKeepingSessionParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: deleteKeepingSession,
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar la sesión'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La sesión se ha eliminado correctamente'));
      queryClient.invalidateQueries({
        queryKey: ['time-keeping-sessions'],
        exact: false,
      });
    },
  });
}
